import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../app/hooks';

import { isOperatorOrHigher } from '../../../utils/userPermissions';

export const useIsOperator = () => {
  const [isOperatorStatus, setIsOperatorStatus] = useState(false);
  const { user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!user) setIsOperatorStatus(false);
    else setIsOperatorStatus(isOperatorOrHigher(user.role));
  }, [user]);

  return isOperatorStatus;
};
